import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { FooterContactUsElementsState } from 'src/main/cms/FooterManagement/FooterManagement';
import { FooterContactUsSingleElement } from './FooterContactUsSingleElement';
import {
    ContactUsListWrapper,
    AddElementsWrapper,
    EditElementsWrapper,
} from 'src/main/cms/FooterManagement/FooterContactUs/FooterContactUsElementsForm.style';
import { FormHeader } from 'src/domains/layouts/shared/cms/form/formHeader/FormHeader';
import { FooterContactUsSingleElementForm } from './FooterContactUsSingleElementForm';

interface FooterContactUsElementsFormPropsType {
    contactUsState: FooterContactUsElementsState;
}

export const FooterContactUsElementsForm = observer(
    'FooterContactUsElementsForm',
    ({ contactUsState }: FooterContactUsElementsFormPropsType) => {
        return (
            <ContactUsListWrapper>
                {contactUsState.contactUsElementsData.length > 0 && (
                    <EditElementsWrapper>
                        <FormHeader
                            isEditMode={false}
                            defaultLabel='Edit contact methods'
                        />
                        {contactUsState.contactUsElementsData.map((contactType) => (
                            <FooterContactUsSingleElement
                                key={contactType.id}
                                contactUsState={contactUsState}
                                contactUsElement={contactType}
                            />
                        ))}
                    </EditElementsWrapper>
                )}
                <AddElementsWrapper>
                    <FormHeader
                        isEditMode={false}
                        defaultLabel='Add contact methods'
                    />
                    {contactUsState.availableContactOptions.map((contactType) => (
                        <FooterContactUsSingleElementForm
                            key={contactType}
                            contactUsState={contactUsState}
                            contactType={contactType}
                        />
                    ))}
                </AddElementsWrapper>
            </ContactUsListWrapper>
        );
    }
);
